module.exports = {
	header : {
		title : 'Area Pendaftar',
	},
	footer : {
		faq : 'Tanya Jawab',
		tnp : 'Syarat & Kebijakan',
		contact : 'Hubungi Kami',
	},

	//SignIn
	signin : {
		head : 'Portal Pendaftar',
		alert : {
			sent : {
				label : 'Silakan cek kotak masuk e-mail Anda',
				desc : 'Tautan khusus untuk mengatur ulang kata sandi telah dikirimkan ke alamat e-mail terdaftar Anda.',
			},
			complete : {
				label : 'Anda baru saja membuat sebuah akun',
				desc : 'Silakan masuk menggunakan alamat e-mail terdaftar dan kata sandi Anda untuk melanjutkan.',
			},
			reset : {
				label : 'Kata sandi telah diatur ulang',
				desc : 'Silakan masuk menggunakan kata sandi baru untuk melanjutkan.',
			},
		},
		form : {
			email : 'Alamat E-mail',
			emailmsg : 'Gagal masuk, silakan cek alamat e-mail Anda.',
			pwd : 'Kata Sandi',
			pwdmsg : 'Atur ulang kata sandi saya',
			resetbtn : 'Lupa kata sandi?',
		},
		agree : '<p class="legalnotice">Dengan melanjutkan, Anda menyatakan setuju kepada <a href="https://borobudurmarathon.com/terms-policy" target="_blank">Syarat Penggunaan dan Kebijakan Privasi</a> kami.</p>',
		btn : 'Masuk',
		reg : 'Daftar',
		errnet : 'Jaringan terputus, silakan cek koneksi internet Anda.',
		reset : {
			head : 'Buat kata sandi baru',
			place1 : 'Masukkan kata sandi baru',
			place2 : 'Ulangi kata sandi baru',
			errmsg1 : 'Satu huruf kecil diwajibkan',
			errmsg2 : 'Satu huruf besar diwajibkan',
			errmsg3 : 'Minimal 8 karakter',
			errmsg4 : 'Satu angka diwajibkan',
			errmsg5 : 'Kata sandi tidak sama',
			btn : 'Konfirmasi',
		},
	},

	//SignUp
	signup : {
		head : 'Pembuatan Akun',
		otp : {
			label : 'Kami baru saja mengirim kode verifikasi ke e-mail Anda.',
			desc : 'Silakan masukkan kode tersebut di sini atau tekan tombol verifikasi di dalam pesan.',
			form : 'Kode Verifikasi',
			btn : 'Verifikasi',
		},
		form : {
			email : 'Alamat e-mail',
			check : 'Cek',
			used : '<h6>Alamat e-mail ini sudah terdaftar.</h6>\
			<p>Jika Anda sudah pernah berpartisipasi di <strong>Borobudur Marathon 2019</strong>, <a href="/signin/resetPasswordRequest?lang=id">lakukan pengaturan ulang kata sandi</a> untuk masuk ke akun Anda.</p>\
			<div class="separator"><p class="center-line"><span>atau</span></p></div>\
			<p style="margin-bottom:0">Jika Anda belum melakukan verifikasi,</p>',
			invitation: {
				head : '<h5>Bagaimana Anda ingin memulai akun baru Anda?</h5>',
				reuse : 'Saya ingin menggunakan data pribadi saya pada pendaftaran 2019',
				new : 'Saya ingin mendaftar sebuah akun baru',
				sent : {
					label : 'Silakan cek kotak masuk e-mail Anda',
					desc : 'Tautan khusus untuk membuat kata sandi baru telah dikirimkan ke alamat e-mail terdaftar Anda.',
				},
			},
			separator: '<div class="separator"><p class="center-line"><span>atau</span></p></div>',
			resendCode : 'kirim ulang kode verifikasi',
			name : 'Nama Lengkap',
			named : 'sesuai yang tercantum pada kartu identitas Anda',
			gender : 'Jenis Kelamin',
			pwd : 'Kata Sandi',
			pwdplace : 'Masukkan kata sandi',
			rpwdplace : 'Ulangi kata sandi',
			errmsg1 : 'Satu huruf kecil diwajibkan',
			errmsg2 : 'Satu huruf besar diwajibkan',
			errmsg3 : 'Minimal 8 karakter',
			errmsg4 : 'Satu angka diwajibkan',
			errmsg5 : 'Kata sandi tidak sama',
			},
		agree : '<p class="legalnotice">Dengan melanjutkan, Anda menyatakan setuju kepada <a href="https://borobudurmarathon.com/terms-policy" target="_blank">Syarat Penggunaan dan Kebijakan Privasi</a> kami.</p>',
		btn : 'Daftar',
		in : 'Masuk',
	},

	//HomeView
	user : {
		linktoprofile : 'Lihat Data Pribadi',
		trivia : 'Tahukah Anda?',
	},
	status : {
		idle : {
			head : 'Borobudur memanggil Anda!',
			label : 'Daftarkan diri Anda sekarang juga.',
			desc : 'Pilih jalur pendaftaran untuk berpartisipasi dalam Borobudur Marathon 2020',
			btn : 'Lanjutkan',
		},
		wait : {
			head : 'Selangkah lagi untuk berlari di Borobudur.',
			label : 'Menunggu hasil pengundian ballot',
			desc : 'Anda baru saja mendaftarkan ballot untuk Borobudur Marathon 2020. Hasil pengundian akan diumumkan pada 9-12 Juni 2020.',
		},
		FRQwait : {
			head : 'Selangkah lagi untuk berlari di Borobudur.',
			label : 'Menunggu hasil seleksi',
			desc : 'Anda baru saja mendaftar <em>fast runner qualification</em> Borobudur Marathon 2020. Hasil seleksi akan diumumkan pada 7-14 May 2020.',
		},
		switched : {
			head : 'Selangkah lagi untuk berlari di Borobudur.',
			label : 'Pendaftarkan dialihkan ke ballot',
			desc : 'Pendaftaran <em>fast runner qualifying</em> Anda telah dialihkan ke ballot. Hasil pengundian akan diumumkan pada 9-12 Juni 2020.',
		},
		drawing : {
			head : 'Selangkah lagi untuk berlari di Borobudur.',
			label : 'Pengundian sedang berlangsung',
			desc : 'Pengundian ballot Borobudur Marathon 2020 sedang berlangsung, hasil pengundian akan diumumkan sebelum 12 Juni 2020.',
		},
		pay : {
			head : 'Selangkah lagi untuk berlari di Borobudur.',
			label : 'Menunggu pembayaran',
			desc : 'Pendaftaran Anda diterima. Pastikan Anda telah menyelesaikan pembayaran sebelum {timelimit} untuk mengamankan slot.',
			btn : 'Lanjutkan pembayaran',
		},
		transferring : {
			head : 'Borobudur menantikan Anda.',
			label : 'Pemindahan bib sedang berlangsung',
			desc : 'Slot Anda sedang dipindahkan. Sampai jumpa di kesempatan berikutnya.',
		},
		success : {
			head : 'Borobudur menantikan Anda.',
			label : 'Slot terkonfirmasi',
			desc : 'Selamat, Anda telah resmi menjadi peserta Borobudur Marathon 2020. Informasi lebih lanjut mengenai persiapan lomba akan segera tersedia di bawah ini.',
		},
		BJsuccess : {
			head : 'Borobudur menantikan Anda.',
			label : 'Slot terkonfirmasi',
			desc : 'Selamat, Anda telah resmi menjadi peserta Borobudur Marathon 2020 melalui program Bank Jateng.',
		},
		unlucky : {
			head : 'Masih ada jalan untuk berlari.',
			label : 'Ballot gagal',
			desc : 'Ballot anda tidak terpilih untuk lomba tahun ini. Silakan mendaftar melalui jalur pendaftaran lain untuk melanjutkan partisipasi dalam Borobudur Marathon 2020.',
		},
		unpaid : {
			head : 'Masih ada jalan untuk berlari',
			label : 'Slot dibatalkan',
			desc : 'Slot Anda telah dibatalkan karena tidak ada pembayaran yang diselesaikan sebelum batas waktu. Silakan mendaftar melalui jalur pendaftaran lain untuk melanjutkan partisipasi dalam Borobudur Marathon 2020.',
		},
		transferred : {
			head : 'Borobudur menantikan Anda.',
			label : 'Slot telah dipindahkan',
			desc : 'Slot Anda telah dipindahkan. Sampai jumpa di kesempatan berikutnya.',
		},
		closed : {
			head : 'Berpartisipasilah di tahun berikutnya.',
			label : 'Periode pendaftaran tahun 2020 telah ditutup',
			desc : 'Selain itu, Anda tetap dapat bergabung dalam Borobudur Marathon 2020 melalui <em>Friendship Run</em>. Daftarkan diri Anda sekarang juga.',
		},
	},
	regData : {
		category : {
			race : 'Kategori Lomba',
			code : 'Kode Pendaftaran',
		},
		details : {
			head : 'Rincian Lomba',
			corral : 'Target Waktu Finis',
			bib : 'Nama pada Bib',
			jersey : 'Ukuran Jersey',
			community : 'Komunitas Lari',
		},
		frq : {
			head : 'Rincian Fast Runner Qualifying',
			qrace: 'Nama Lomba Kualifikasi',
			qcategory : 'Kategori Lomba Kualifikasi',
			qtime : 'Waktu Finis Lomba Kualifikasi',
		},
		emergency : {
			head : 'Rincian Darurat & Medis',
			name : 'Nama Kontak Darurat',
			number : 'Nomor Kontak Darurat',
			medic : 'Kondisi Medis',
		},
	},
	friendship : {
		card : {
			head : 'Friendship Run',
			desc : 'Friendship Run dipersembahkan bagi semua orang yang ingin menikmati keindahan alam, kekayaan budaya dan kenikmatan kuliner khas Magelang.',
			btn : 'Daftar Sekarang',
		},
		modal : {
			head : 'Pendaftaran Friendship Run',
			desc : 'Dipersembahkan bagi semua orang yang ingin menikmati keindahan alam, kekayaan budaya dan kenikmatan kuliner khas Magelang. Jalan santai atau lari ringan bukan masalah, mari daftar segera untuk bisa bersenang-senang dengan keluarga dan teman di Friendship Run!',
			cta : 'Lebih Lanjut',
			icon1h : 'Waktu Mulai',
			icon1d : 'Sabtu, 14 November 2020<br/>06.00 WIB (GMT+7)',
			icon2h : 'Lokasi',
			icon2d : 'Candi Pawon<br/>Magelang, Jawa Tengah, Indonesia',
			icon3h : 'Harga',
			icon3d : 'Rp 125.000<br/>per orang',
			msg : 'Tidak perlu lagi memasukkan data diri karena Anda telah mendaftar akun di Borobudur Marathon. Silakan klik tombol ikut di bawah dan selesaikan pembayaran untuk berpartisipasi dalam Friendship Run.',
			btn : 'Ikuti Friendship Run',
		},
		status : {
			pay : {
				label : 'Menunggu pembayaran',
				desc : 'Pastikan telah menyelesaikan pembayaran sebelum <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> untuk menyelesaikan pendaftaran.',
				btn : 'Bayar Sekarang',
				jbtn : 'Pilih Ukuran Jersey',
			},
			unpaid : {
				label : 'Pendaftaran dibatalkan',
				desc : 'Pendaftaran Anda telah dibatalkan karena tidak ada pembayaran yang diselesaikan sebelum batas waktu.',
				btn : 'Daftar Ulang',
			},
			success : {
				label : 'Siap berlari',
				desc : 'Jangan lupa untuk menikmati keindahan alam, kekayaan budaya dan kenikmatan kuliner khas Magelang!',
			},
		},
		data : {
			code : 'Kode Daftar',
			bib : 'No. Bib',
			btn : 'Lebih Lanjut',
		},
	},
	shuttle : {
		card : {
			head : 'Layanan Bus',
			desc : 'Borobudur Marathon menyediakan layanan bus untuk Anda yang menginap di Yogyakarta atau Magelang menuju ke lokasi acara pada hari lomba.',
			btn : 'Beli Tiket',
		},
		modal : {
			head : 'Layanan Bus',
			lpoint : 'Lokasi Keberangkatan & Kepulangan',
			p1 : '<h5>Plaza Ambarrukmo Yogyakarta</h5><p>Jalan Laksda Adisucipto No. 80, Sleman, Yogyakarta 56172</p>\
			<p>Keberangkatan Pertama: 02.00 WIB<br>Keberangkatan Terakhir: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/b4TZD8ApPGuzWDKn7" class="btn btn-outline-secondary btn-sm rounded-pill">Petunjuk Arah <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p2 : '<h5>Abu Bakar Ali Parking Area</h5><p>Jalan Abu Bakar Ali No. 1, Danurejan, Yogyakarta 55213</p>\
			<p>Keberangkatan Pertama: 02.00 WIB<br>Keberangkatan Terakhir: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/SnNZs3MiBtVoeSJu8" class="btn btn-outline-secondary btn-sm rounded-pill">Petunjuk Arah <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p3 : '<h5>Televisi Republik Indonesia Yogyakarta</h5><p>Jalan Magelang No. 74, Sleman, Yogyakarta 55284</p>\
			<p>Keberangkatan Pertama: 02.00 WIB<br>Keberangkatan Terakhir: 02.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/ccxsFcNiBQzujDwT7" class="btn btn-outline-secondary btn-sm rounded-pill">Petunjuk Arah <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			p4 : '<h5>Armada Town Square Magelang</h5><p>Jalan Mayjen Bambang Soegeng No. 1, Magelang, Central Java 56172</p>\
			<p>Keberangkatan Pertama: 03.00 WIB<br>Keberangkatan Terakhir: 03.30 WIB</p>\
			<a rel="noopener" target="_blank" href="https://goo.gl/maps/5wFj2zbAgVZhtVhUA" class="btn btn-outline-secondary btn-sm rounded-pill">Petunjuk Arah <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
			lform : 'Pembelian Tiket',
			fpoint : 'Lokasi Keberangkatan & Kepulangan',
			fpointdesc : 'Pilih lokasi keberangkatan dan kepulangan menuju dan dari lokasi lomba',
			freturn : 'Waktu Kepulangan',
			freturndesc : 'Pilih jadwal waktu kepulangan dari lokasi lomba ke lokasi kepulangan',
			fbtn : 'Beli Tiket',
		},
		status : {
			pay : {
				label : 'Menunggu pembayaran',
				desc : 'Pastikan telah menyelesaikan pembayaran sebelum <strong>{{transactionData.data.trnsExpiredTime | moment("D MMMM YYYY HH:mm")}} WIB (GMT+7)</strong> untuk menyelesaikan pendaftaran.',
				btn : 'Bayar Sekarang',
			},
			unpaid : {
				label : 'Tiket dibatalkan',
				desc : 'Tiket Anda telah dibatalkan karena tidak ada pembayaran yang diselesaikan sebelum batas waktu.',
				btn : 'Beli Ulang',
			},
			success : {
				label : 'Tiket Anda sudah siap',
				desc : 'Berikut adalah rincian tiket layanan bus Anda. Sampai jumpa di hari lomba!',
			},
		},
		data : {
			code : 'Kode Tiket',
			point : 'Lokasi',
			dep : 'Waktu Keberangkatan',
			ret : 'Waktu Kepulangan',
		},
	},
	bib : {
		card : {
			head : 'Pemindahan Bib',
			desc : 'Layanan pemindahan bib disediakan untuk pendaftar yang ingin mengalihkan kepemilikan slot partisipasi Borobudur Marathon.',
			btn : 'Pindahkan Bib Saya',
		},
		modal : {
			head : 'Pemindahan Bib',
			date : '21 September - 5 Oktober 2020',
			step : '<div class="col"><div class="point"><h1>1</h1><p align="center">\
			Mulai pemindahan bib dengan mendaftarkan nama lengkap dan alamat e-mail penerima.\
			</p></div></div><div class="col"><div class="point"><h1>2</h1><p align="center">\
			Penerima akan menerima tautan undangan pada e-mailnya untuk mulai mendaftarkan data diri peserta.\
			</p></div></div><div class="col"><div class="point"><h1>3</h1><p align="center">\
			Setelah penerima menyelesaikan pembayaran biaya administrasi, slot partisipasi Anda telah sukses dialihkan.</p></div></div>',
			ltnc : 'Syarat dan Ketentuan',
			tnc : '<ol>\
				<li>Pemindahan nomor bib hanya berlaku untuk Peserta yang mendaftar melalui Pendaftaran Ballot. Peserta yang mendaftar melalui Fast Runner Qualifying, Program Mitra Agen Perjalanan, Program Bank Jateng dan program lainnya dari Borobudur Marathon, termasuk yang menerima undangan dan free slot dari Borobudur Marathon tidak dapat memindahkan nomor bib.</li>\
				<li>Nomor bib merupakan identifikasi resmi Peserta selama acara dan harus digunakan ketika Peserta berada pada <em>run course</em>.</li>\
				<li>Pemindahan nomor bib resmi hanya dapat dilakukan melalui situs web resmi Borobudur Marathon 2019 selama Periode Pemindahan Nomor Bib (sebagaimana didefinisikan di bawah ini).</li>\
				<li>Pemindahan nomor bib hanya dapat dilakukan selama Periode Pemindahan Nomor Bib, yaitu sejak tanggal 15 Agustus 2019 sampai dengan 26 Agustus 2019. Permohonan pemindahan nomor bib yang melewati Periode Pemindahan Nomor Bib tidak akan dilayani.</li>\
				<li>Pemindahan nomor bib adalah proses pemindahan nomor bib Transferor (sebagaimana didefinisikan di bawah ini) kepada Transferee (sebagaimana didefinisikan di bawah ini). Oleh karenanya, pemindahan nomor bib mengakibatkan penggantian Transferor oleh Transferee sebagai Peserta dalam kategori jarak yang sama yang didaftarkan oleh Transferee sebelumnya. Para pihak dalam pemindahan nomor bib (Transferor dan Transferee) tidak dapat mengubah kategori jarak.</li>\
				<li>Proses pemindahan nomor bib harus diajukan oleh pemilik bib (“Transferor”) dengan cara memilih untuk memindahkan nomor bib nya melalui situs web resmi Borobudur Marathon dan memasukkan alamat email penerima bib.</li>\
				<li>Setiap Transferor hanya dapat melakukan satu kali proses pemindahan nomor bib terhadap satu alamat email penerima bib.</li>\
				<li>Mohon diperhatikan nomor bib tidak dapat dipindahkan kepada pihak yang telah terdaftar sebagai Peserta. Untuk mencegah keragu-raguan, Peserta merupakan pihak yang menerima email konfirmasi resmi Borobudur Marathon yang mengkonfirmasi masuknya pihak tersebut sebagai peserta Borobudur Marathon 2019, melalui Pendaftaran Ballot, Fast Runner Qualifying, Program Mitra Agen Perjalanan, Bank Jateng Program atau program lainnya dari Borobudur Marathon termasuk pihak yang menerima undangan dan free slot dari Borobudur Marathon.</li> \
				<li>Penerima bib (“Transferee”) akan menerima email setelah prosedur pemindahan diajukan oleh Transferor. Transferee akan menerima email dari Borobudur Marathon yang berisikan instruksi biaya pemindahan sebesar Rp 100.000,- (seratus ribu rupiah) melalui pilihan pembayaran yang tersedia dalam situs web.</li> \
				<li>Dengan berhasilnya proses pemindahan nomor bib mengakibatkan Transferee menjadi Peserta dan Transferor tidak lagi merupakan Peserta. Lebih lanjut, Transferee tidak dapat melakukan proses pemindahan nomor bib kepada siapapun.</li> \
				<li>Biaya pemindahan hanya dapat dibayar selama Periode Pemindahan Nomor Bib. Pembayaran yang melebihi Periode Pemindahan Nomor Bib dibatalkan dan proses pemindahan nomor bib menjadi batal. Pembayaran tersebut tidak dapat dikembalikan.</li>\
				<li>Jika proses pemindahan nomor bib dibatalkan karena pembayaran yang terlambat, nomor bib tetap berada pada Transferor dan Transferor tidak dapat lagi melakukan proses pemindahan nomor bib.</li>\
				</ol>',
			lform : 'Formulir Pengajuan Pemindahan Bib',
			fname : 'Nama Lengkap Penerima',
			fnamedesc : 'sesuai yang tercantum pada kartu identitas mereka',
			femail : 'Alamat E-mail Penerima',
			femaildesc : 'Kami akan mengirim tautan undangan ke alamat e-mail ini',
			facceptance : 'Dengan mengajukan pemindahan bib, maka:\
			<ul><li>Anda setuju untuk melakukan pemindahan bib.</li>\
			<li>Anda mengerti bahwa pemindahan bib hanya dapat dilakukan satu kali kepada penerima terdaftar di atas dan tidak dapat diganti atau dibatalkan oleh Anda (transferor).</li>\
			<li>Ketika pemindahan bib berhasil, Anda tidak lagi menjadi peserta dan tidak dapat menggunakan slot Borobudur Marathon 2020 yang telah dipindahkan transferee.</li></ul>',
			btn : 'Pindahkan Bib Saya',
		},
	},
	rpc : {
		card : {
			head : 'Pengambilan Race Pack',
			desc : 'Kami menyarankan Anda untuk mengambil race pack secara mandiri dan menikmati berbagai hiburan, anjungan, dan kuliner khas dalam race expo kami. Atau, Anda dapat mendelegasikan pengambilan race pack kepada perwakilan terpercaya Anda.',
		},
		schedule : '<div class="groupLabel"><label>Jadwal</label></div>\
			<table>\
				<tbody><tr>\
					<td class="heady">Kamis, 12 November</td>\
					<td>10.00 – 20.00 WIB</td>\
				</tr><tr>\
					<td class="heady">Jumat, 13 November</td>\
					<td>10.00 – 20.00 WIB</td>\
				</tr><tr>\
					<td class="heady">Sabtu, 14 November</td>\
					<td>10.00 – 18.00 WIB</td>\
				</tr></tbody>\
			</table>\
			<small><em>Waktu Indonesia Barat (WIB) / GMT+7</em></small>\
		',
		venue : '<div class="groupLabel"><label>Lokasi</label></div>\
		<h5>Armada Town Square</h5>\
		<p>Jalan Mayjen Bambang Soegeng No. 1, Mertoyudan, Magelang, Jawa Tengah 56172</p>\
		<a rel="noopener" target="_blank" href="https://goo.gl/maps/eX5q5GTcTFrMDWF16" class="btn btn-outline-secondary btn-sm rounded-pill">Petunjuk Arah <svg width="1em" height="1em" viewBox="0 0 20 20" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M12.146 6.646a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L14.793 10l-2.647-2.646a.5.5 0 010-.708z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M4 10a.5.5 0 01.5-.5H15a.5.5 0 010 1H4.5A.5.5 0 014 10z" clip-rule="evenodd"></path></g></svg></a>',
		instructions : {
			label : 'Instruksi',
			point : '<ol>\
			<li>Datang ke lokasi pengambilan <em>race pack</em> pada jadwal dan lokasi yang telah ditentuakan. Mohon diingat bahwa tidak ada pengambilan <em>race pack</em> diluar jadwal dan lokasi yang telah ditentukan.</li>\
			<li>Tunjukkan kartu identitas atau paspor terdaftar Anda beserta kode QR di atas kepada petugas kami.</li>\
			<li>Jika Anda adalah peserta dengan usia dibawah 18 tahun pada hari lomba, Anda diwajibkan membawa <a href="https://assets.heartwork.co.id/bormar/2020-parental-consent-letter.pdf"><strong>surat persetujuan orang tua</strong></a> yang telah terisi lengkap dan ditandatangani.</li>\
			<li>Terima <em>race pack</em> Anda dan periksa kembali untuk memastikan bahwa <em>race pack</em> yang Anda terima telah lengkap. Anda juga dapat mencoba <em>tag</em> pemantau pada bib Anda di booth yang telah disediakan.</li>\
			<li>Setelah mengambil <em>race pack</em>, ikuti dan rasakan keseruan <a href="https://borobudurmarathon.com/id/expo-lomba"><strong>Expo</strong></a> kami.</li>\
			</ol>',
			btn : 'Delegasikan pengambilan race pack saya'
		},
		delegation : {
			label : 'Delegasi Pengambilan Race Pack',
			statuslabel: 'Pengambilan Race Pack Anda telah didelegasikan',
			statusdesc : 'Kami telah mengirimkan kode pengambilan race pack Anda kepada perwakilan di bawah ini. Silakan hubungi perwakilan Anda untuk informasi lebih lanjut mengenai race pack atau klik tombol pembatalan jika Anda ingin mengambil race pack secara mandiri.',
			rname : 'Nama Lengkap Perwakilan',
			remail : 'Alamat E-mail Perwakilan',
			rphone : 'Nomor Telepon Perwakilan',
			cancel : 'Batalkan delegasi pengambilan race pack saya',
		},
	},
	delrpc : {
		head : 'Delegasi Pengambilan Race Pack',
		lform : 'Surat Kuasa',
		fname : 'Nama Lengkap Perwakilan',
		fnamedesc : 'sesuai yang tercantum pada kartu identitas mereka',
		femail : 'Alamat E-mail Perwakilan',
		femaildesc : 'Kami akan mengirimkan kode pengambilan race pack Anda ke alamat e-mail ini',
		fphone : 'Nomor Telepon Perwakilan',
		facceptance : 'Dengan mengajukan surat kuasa, Saya mengerti bahwa:\
		<ol>\
		<li>Pendelegasian pengambilan <em>race pack</em> ini bukan pengalihan nomor bib. Pihak yang didelegasikan sama sekali tidak berhak untuk berlari dalam Borobudur Marathon 2019 menggunakan nomor bib Anda.</li>\
		<li>Setelah menekan tombol konfirmasi di bawah, hak Anda untuk mengambil <em>race pack</em> akan dialihkan kepada pihak yang didelegasikan berupa penerbitan kode pengambilan <em>race pack</em> baru yang akan dikirim ke detail kontak yang tertera di atas.</li>\
		<li>Anda dapat membatalkan pendelegasian pengambilan <em>race pack</em> dan mendapatkan hak pengambilan <em>race pack</em> secara mandiri dengan menekan tombol pembatalan yang terdapat di Area Pendaftar.</li></ol>',
		btn : 'Ajukan',
	},
	raceday : {
		card : {
			head : 'Hari Lomba',
			desc : 'Temukan informasi lebih lanjut mengenai akses masuk, waktu mulai, program acara, peta race central, lokasi parkir dan penutupan jalan pada hari lomba.',
			btn : 'Lebih Lanjut',
		},
	},
	
	//ProfileView
	profile : {
		status : {
			verified : 'Terverifikasi',
			verifying : 'Memverifikasi',
			failed : 'Verifikasi Gagal',
			pending : 'Verifikasi Ditangguhkan',
		},
		pendingmsg : 'Kami membutuhkan waktu untuk memverifikasi kartu identitas terunggah dengan data pribadi Anda.<br/>Sementara itu, Anda dapat melakukan pendaftaran dengan melanjutkan ke dasbor.',
		updatebtn : 'Perbarui Data Pribadi',
		reqbtn : 'Ajukan Verifikasi Manual',
		reqmsg : 'Pengajuan verifikasi manual telah terkirim dan tim kami akan memverifikasi kartu identitas terunggah dengan data pribadi Anda secara langsung. Silakan mengecek kembali status verifikasi Anda dalam 2x24 jam.',
		resetbtn : 'Atur Ulang Kata Sandi',
		resetmsg : 'Tautan khusus untuk mengatur ulang kata sandi telah dikirimkan ke alamat e-mail terdaftar Anda.',
		dash : 'Kembali ke Dasbor',
		card : {
			details : {
				head : 'Rincian Pribadi',
				nat : 'Kewarganegaraan',
				gen : 'Jenis Kelamin',
				blo : 'Golongan Darah',
				dob : 'Tanggal Lahir',
				pob : 'Tempat Lahir',
			},
			id : {
				head : 'Kartu Identitas',
				typ : 'Tipe Kartu Identitas',
				num : 'Nomor Kartu Identitas',
				edu : 'Pendidikan',
				ocu : 'Pekerjaan',
			},
			com : {
				head : 'Rincian Korespondensi',
				ema : 'E-mail',
				pho : 'Nomor Telepon',
				add : 'Alamat',
				cit : 'Kota/Kabupaten',
				pro : 'Propinsi',
				cou : 'Negara',
			},
		},
	},
	validate : {
		alert : {
			reject : '<h6 class="text-center">Tidak dapat memverifikasi kartu identitas</h6>\
			<p class="text-center">Silakan mengunggah kartu identitas lain yang cocok dengan data pribadi Anda untuk melanjutkan.</p>'
		},
		phone : {
			head : 'Verifikasi nomor telepon Anda',
			desc : 'Kami akan mengirimkan kode verifikasi melalui SMS untuk memverifikasi bahwa nomor telepon Anda adalah aktif dan siap menerima pemberitahuan penting dari kami.',
			label : 'Nomor Telepon',
			send : 'Kirim kode melalui SMS',
		},
		otp : {
			label : 'Masukkan Kode Verifikasi',
			place : '6 digit Kode Verifikasi',
			btnv : 'Verifikasi',
			btnr : 'Kirim Ulang',
			later : 'Tunda Validasi',
		},
		id : {
			head : 'Validasi kartu identitas Anda',
			labeltype : 'Tipe Kartu Identitas',
			labelfile : 'Berkas Kartu Identitas',
			descfile : 'Unggah berkas kartu identitas Anda dalam format JPG/JPEG/PNG (maks. 2 MB)',
			placefile : 'Pilih berkas atau turunkan ke sini',
			dropfile : 'Turunkan berkas di sini',
			labelselect : 'Berkas terpilih:',
			btn : 'Unggah kartu identitas saya',
		},
		data : {
			head : 'Selangkah lagi untuk melengkapi profil Anda',
			idlabel : 'Nomor Kartu Identitas',
			iddesc : 'sesuai yang tercantum pada kartu identitas Anda',
			doblabel : 'Tanggal Lahir',
			dobd : 'sesuai yang tercantum pada kartu identitas Anda dengan usia minimum untuk mendaftar adalah 14 (empat belas) tahun dari hari lomba pada tahun ini.',
			poblabel : 'Tempat Lahir',
			pobd : 'sesuai yang tercantum pada kartu identitas Anda',
			blo : 'Golongan Darah',
			nat : 'Kewarganegaraan',
			cou : 'Negara',
			dom : 'Alamat Domisili',
			domdesc : 'Ketik dan pilih nama kota/kabupaten pada daftar pilihan yang tersedia.',
			add : 'Alamat',
			cit : 'Kota/Kabupaten',
			pro : 'Propinsi',
			edu : 'Pendidikan',
			ocu : 'Pekerjaan',
			inc : 'Pendapatan Bulanan',
			accnews : 'Saya setuju untuk menerima berita dan promosi eksklusif untuk pendaftar Borobudur Marathon.',
			accok : 'Saya yakin bahwa data pribadi saya adalah akurat.',
			acctnp : 'Saya telah membaca dan menyetujui <a href="https://borobudurmarathon.com/terms-policy" target="_blank">syarat penggunaan dan kebijakan privasi</a> Borobudur Marathon.',
			btn : 'Lengkapi profil saya',
		},
		select : {
			edu : {
				e1 : 'Sekolah Dasar',
				e2 : 'Sekolah Menengah Pertama',
				e3 : 'Sekolah Menengah Atas',
				e4 : 'Diploma (D1/D2/D3)',
				e5 : 'Sarjana (S1)',
				e6 : 'Magister (S2)',
				e7 : 'Doktor (S3)',
			},
			ocu : {
				o1 : 'Pekerja Bisnis & Finansial',
				o2 : 'Pegawai Negeri Sipil',
				o3 : 'Tenaga Pendidik',
				o4 : 'Wiraswasta',
				o5 : 'Pekerja Lepas',
				o6 : 'Tenaga Medis',
				o7 : 'Pekerja Industri',
				o8 : 'Aparat Penegak Hukum',
				o9 : 'Karyawan Swasta',
				o10 : 'Profesional',
				o11 : 'Pelajar',
				o12 : 'Belum/Tidak Bekerja',
				o13 : 'Lainnya',
			},
			inc : {
				i1 : '< Rp 1.000.000 atau < $ 100',
				i2 : 'Rp 1.000.000—5.000.000 atau $ 100—500',
				i3 : 'Rp 5.000.000—10.000.000 atau $ 500—1000',
				i4 : 'Rp 10.000.000—25.000.000 atau $ 1000—2500',
				i5 : 'Rp 25.000.000—50.000.000 atau $ 2500—5000',
				i6 : '> Rp 50.000.000 atau > $ 5000',
			},
		},
	},

	//RegistrationModal
	register : {
		ballot : 'Pendaftaran Ballot',
		frq : 'Fast Runner Qualifying',
		bankjateng : 'Program Bank Jateng',
		travel : 'Mitra Agen Perjalanan',

		form : {
			voucher : {
				label : 'Rincian Pendaftaran',
				code : 'Kode Voucher',
				bjcode : 'Kode voucher untuk pendaftaran melalui program Bank Jateng. Silakan hubungi Call Center Bank Jateng 14066 untuk informasi lebih lanjut.',
				trcode : 'Kode voucher untuk pendaftaran melalui mitra agen perjalanan. Silakan hubungi mitra agen perjalanan kami untuk informasi lebih lanjut.',
			},
			detail : {
				label : 'Rincian Lomba',
				race : 'Kategori Lomba',
				raced : 'Pilih kategori lomba yang Anda inginkan dalam Borobudur Marathon 2020',
				time : 'Target Waktu Finis',
				timed : 'Pilih target waktu dalam jam dan menit untuk menyelesaikan lomba',
				bib : 'Nama pada Bib',
				bibd : 'Nama untuk ditampilkan pada bib (maks. 16 karakter)',
				jersey : 'Ukuran Jersey',
				jerseyd : 'Pilih ukuran jersey Anda',
				comm : 'Komunitas Lari',
				commd : 'Pilih dari daftar yang tersedia atau ketik dan tekan enter untuk menambahkan komunitas lari Anda sendiri (opsional)'
			},
			frq : {
				label : 'Rincian Kualifikasi',
				qrace : 'Nama Lomba Kualifikasi',
				qraced : 'Nama lomba di mana Anda memiliki waktu finis tercepat dalam 2 (dua) tahun terakhir',
				qcat : 'Kategori Lomba Kualifikasi',
				qcatd : 'Kategori pada lomba kualifikasi di atas',
				qtime : 'Waktu Finis pada Lomba Kualifikasi',
				qtimed : 'Waktu finis resmi pada lomba kualifikasi di atas',
				qfile : 'Berkas Sertifikat Lomba Kualifikasi',
				qfiled : 'Unggah berkas sertifikat resmi yang mencantumkan waktu finis Anda dalam format PDF/PNG/JPG (maks. 5 MB)',
				qurl : 'Tautan Sertifikat Lomba Kualifikasi',
				qurld : 'Masukkan tautan meunuju sertifikat resmi dari situs web resmi lomba kualifikasi di atas (opsional)',
				qurlp : 'https://www.racetecresults.com/cert.aspx?uid=19723-66-4-123094',
			},
			emergency : {
				label : 'Rincian Darurat & Medis',
				name : 'Nama Kontak Darurat',
				named : 'Orang terpercaya untuk dihubungi pada kondisi darurat',
				number : 'Nomor Kontak Darurat',
				medic : 'Kondisi Medis',
				medicd : 'Deskripsikan kondisi medis Anda secara detail (opsional)'
			},
			acceptance : 'Dengan mengirim formulir pendaftaran, maka:\
			<ul><li>Anda menyatakan bahwa Anda sudah membaca dan menyetujui <a href="https://borobudurmarathon.com/peraturan/" target="_blank">peraturan dan ketentuan</a>.</li>\
			<li>Anda yakin bahwa data pendaftaran yang Anda masukkan adalah akurat.</li>\
			<li>Anda mengerti bahwa pendaftaran hanya dapat dilakukan satu kali dan Anda tidak bisa menggantinya setelah pengiriman.</li>\
			</ul>',
			btn : 'Daftar',
			jbtn : 'Kirim',
		},
	},

	//PaymentModal
	payment : {
		head : 'Pembayaran',
		currency : 'Rp',
		code : 'Kode Pembayaran',
		limit : 'Batas Waktu Pembayaran',
		voucher : 'Kode Voucher',
		apply : 'Terapkan',

		pay : 'Pilih Metode Pembayaran yang Anda inginkan',
		paycc : '<img src="https://assets.heartwork.co.id/bormar/cc.png" style="width:200px"><br/>\
		<strong>Kartu Kredit/Debit</strong><br/>\
		<span>Bayar menggunakan kartu kredit atau debit Visa/MasterCard/JCB</span>',
		paybt : '<img src="https://assets.heartwork.co.id/bormar/bt.png" style="width:100px"><br/>\
		<strong>Transfer Bank</strong><br/>\
		<span>Bayar menggunakan nomor rekening virtual Bank Jateng melalui ATM</span>',

		trans : 'Instruksi Transfer Bank',
		va : 'Nomor Rekening Virtual',
		swift : 'Kode Swift',
		atmbj : '<ol>\
		<li>Pada menu utama, pilih "Transfer".</li>\
		<li>Masukkan nomor rekning virtual tujuan pembayaran: <strong>{{validVA.jtvaVANumber}}</strong>.</li>\
		<li>Masukkan nominal angka sesuai dengan <strong>total pembayaran</strong> (tanpa pembulatan). Jumlah pembayaran yang tidak sesuai dengan total tagihan akan mengakibatkan pembatalan transaksi</li>\
		<li>Pada laman "Konfirmasi Transfer", pastikan <strong>nama Anda</strong> tercantum sebagai rekening tujuan pembayaran.</li>\
		<li>Pilih "Benar" untuk menyelesaikan pembayaran.</li>\
		<li>Simpan bukti transfer untuk kebutuhan konfirmasi di kemudian hari.</li>\
		</li></ol>',
		atmb : '<ol>\
		<li>Pada menu utama, pilih menu "Transaksi Lainnya".</li>\
		<li>Pilih "Transfer".</li>\
		<li>Pilih "Antar Bank".</li>\
		<li>Masukkan kode Bank Jateng "113" diikuti oleh 11 digit nomor rekening <em>Virtual Account</em> tujuan pembayaran. <strong>(113{{validVA.jtvaVANumber}})</strong></li>\
		<li>Pastikan <strong>nama Anda</strong> tercantum sebagai rekening tujuan pembayaran.</li>\
		<li>Masukkan nominal angka sesuai dengan <strong>total pembayaran</strong> (tanpa pembulatan). Jumlah pembayaran yang tidak sesuai dengan total tagihan akan mengakibatkan pembatalan transaksi.</li>\
		<li>Tidak perlu memasukkan nomor referensi kemudian pilih "Benar".</li>\
		<li>Pilih asal sumber dana yaitu "Giro" atau "Tabungan".</li>\
		<li>Simpan bukti transfer untuk kebutuhan konfirmasi di kemudian hari.</li>\
		</li></ol>',
		atmp : '<ol>\
		<li>Pada menu utama, pilih "Transaksi".</li>\
		<li>Pilih "Transfer Link/ATM Bersama/Prima".</li>\
		<li>Masukkan nominal angka sesuai dengan <strong>total pembayaran</strong> (tanpa pembulatan). Jumlah pembayaran yang tidak sesuai dengan total tagihan akan mengakibatkan pembatalan transaksi.</li>\
		<li>Masukkan kode Bank Jateng: 113.</li>\
		<li>Masukkan nomor rekning virtual tujuan pembayaran: <strong>{{validVA.jtvaVANumber}}</strong>.</li>\
		<li>Pada laman "Konfirmasi Transfer", pastikan <strong>nama Anda</strong> tercantum sebagai rekening tujuan pembayaran.</li>\
		<li>Pilih "Benar" untuk menyelesaikan pembayaran.</li>\
		<li>Simpan bukti transfer untuk kebutuhan konfirmasi di kemudian hari.</li>\
		</li></ol>',
	},
};


// WEBPACK FOOTER //
// src/languages/indonesia.js